var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "cover-img-top shadow" }, [
      _c("img", {
        staticClass: "img-fluid card-img-top cover-img-top",
        staticStyle: { "object-fit": "cover" },
        attrs: {
          alt: "Cover Image",
          src:
            _vm.supplier.supplier_cover_image === null
              ? "/images/cover.jpg"
              : _vm.supplier.supplier_cover_image.url,
        },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card-content" }, [
      _c("div", { staticClass: "card-header pt-05 mb-1" }, [
        _c(
          "div",
          { staticClass: "col-12 col-md-3 col-lg-2 pr-0 pl-0 text-center" },
          [
            _c(
              "div",
              {
                staticClass: "avatar avatar-xxl",
                staticStyle: { "margin-top": "-90px" },
              },
              [
                _c("img", {
                  staticClass: "rounded-circle shadow",
                  attrs: {
                    alt: "Avatar Image",
                    src:
                      _vm.supplier.supplier_avatar === null
                        ? "/images/avatar.png"
                        : _vm.supplier.supplier_avatar.url,
                  },
                }),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-md-9 col-lg-10 pl-0 pr-0" }, [
          _c("h1", { staticClass: "pb-0 mb-0 font-large-2" }, [
            _vm._v(_vm._s(_vm.supplier.title)),
          ]),
          _vm._v(" "),
          _vm.supplier.supplier_tag_name !== null
            ? _c(
                "span",
                { staticClass: "pb-0 mb-0 text-bold-700 text-primary" },
                [_vm._v(_vm._s(_vm.supplier.supplier_tag_name) + " ")]
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-body row pb-1" }, [
        _c("div", { staticClass: "col-12 col-md-12 col-lg-4" }, [
          _c("div", { staticClass: "d-inline-block text-dark font-medium-3" }, [
            _vm.supplier.privacy === "1"
              ? _c(
                  "span",
                  { staticClass: "badge badge-pill badge-light pr-05" },
                  [
                    _c("i", {
                      staticClass: "fa fa-shield-alt",
                      attrs: {
                        "data-toggle": "tooltip",
                        "data-placement": "bottom",
                        title: "Private Page",
                      },
                    }),
                    _vm._v(" Private\n                    "),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("p", { staticClass: "badge badge-pill primary" }, [
              _c("i", { staticClass: "fa fa-users text-white" }),
              _vm._v(" "),
              _c("span", { staticClass: " text-white" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.supplier.follower_count) +
                    " " +
                    _vm._s(
                      _vm.supplier.follower_count === 1
                        ? "Follower"
                        : _vm.__("supplier.title_followers")
                    )
                ),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _vm._m(0),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-12 col-md-12" }, [
      _c("div", { staticClass: "card p-1" }, [
        _c("div", { staticClass: "card-title" }, [
          _c("h4", { staticClass: "mb-1 pb-05 border-bottom" }, [
            _c("i", { staticClass: "feather icon-users" }),
            _vm._v(" " + _vm._s(_vm.supplier.title) + "\n                "),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card-body p-0" }, [
          _c("span", {
            staticClass: "breakAll image-resize",
            domProps: { innerHTML: _vm._s(_vm.supplier.description) },
          }),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-12 col-md-12 col-lg-8 float-right text-right pr-05 pl-05",
      },
      [
        _c("div", { staticClass: "d-flex justify-content-around" }, [
          _c(
            "a",
            {
              staticClass: "btn btn-primary waves-light mr-05 profile-menu",
              attrs: {
                href: "#",
                "data-toggle": "modal",
                "data-target": "#registerModal",
              },
            },
            [
              _c("i", { staticClass: "feather icon-send mobile-hide" }),
              _vm._v(" Posts\n                    "),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn-primary waves-light mr-05 profile-menu",
              attrs: {
                href: "#",
                "data-toggle": "modal",
                "data-target": "#registerModal",
              },
            },
            [
              _c("i", { staticClass: "feather icon-calendar mobile-hide" }),
              _vm._v(" Events\n                    "),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn-primary waves-light mr-05 profile-menu",
              attrs: {
                href: "#",
                "data-toggle": "modal",
                "data-target": "#registerModal",
              },
            },
            [
              _c("i", {
                staticClass: "feather icon-shopping-cart mobile-hide",
              }),
              _vm._v(" Store\n                    "),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn-primary profile-menu mr-05",
              attrs: {
                href: "#",
                "data-toggle": "modal",
                "data-target": "#registerModal",
              },
            },
            [
              _c("i", { staticClass: "feather icon-users mobile-hide" }),
              _vm._v(" Resources\n                    "),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn-primary waves-light mr-05 profile-menu",
              attrs: {
                href: "#",
                "data-toggle": "modal",
                "data-target": "#registerModal",
              },
            },
            [
              _c("i", { staticClass: "feather icon-video mobile-hide" }),
              _vm._v(" Videos\n                    "),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn-primary waves-light profile-menu",
              attrs: {
                href: "#",
                "data-toggle": "modal",
                "data-target": "#registerModal",
              },
            },
            [
              _c("i", { staticClass: "feather icon-users mobile-hide" }),
              _vm._v(" Followers\n                    "),
            ]
          ),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }